@if (items && items.length > 0) {
  <div class="breadcrumb-wrapper">
    <p-breadcrumb class="w-full crumb" [model]="items" [home]="home"></p-breadcrumb>
  </div>
}

<div class="page-inner-body portlet light">
  <div class="portlet-body">

    <div class="top-action-bar">
      <div class="row">
        <div class="col-md-12">
          @if (artist) {
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center py-2">
                @if (artist.ImgUrl) {
                  <img [src]="artist.ImgUrl" class="rounded-circle me-1 cursor-pointer" height="32"
                    (click)="viewArtistDetails(artist.UserName)" />
                }
                <span class="fs-3 cursor-pointer text-primary fw-semibold"
                (click)="viewArtistDetails(artist.UserName)">{{ artist.Name }}</span>
                @if (artist.BusinessName) {
                  <span class="fs-5 small ms-2">
                    {{ 'viewArtist.tradingAs' | transloco: { name: artist.BusinessName } }}
                  </span>
                }
                <!-- 👇 Artwork count badge style same as availableGalleryProducts -->
                @if (artistProductsLoaded && availableArtworks > 0) {
                  <span class="fs-5 small ms-2">
                    |
                    <span class="badge rounded-pill ms-2" style="background-color: #2E8B8B; color: white;">
                      {{ availableArtworks }}
                    </span>
                    {{ 'viewArtist.artworksOnHand' | transloco }}
                  </span>
                }
              </div>
              <div class="d-flex align-items-center justify-content-center cursor-pointer"
                (click)="onShowArtistOverlay($event)">
                <span>{{ 'viewArtist.seeMore' | transloco }}</span>
                <i class="pi pi-chevron-down mt-1" style="margin-left: 10px;"></i>
              </div>
            </div>
          }

        </div>
        <!-- Artist Notes -->
        <div class="card mt-2">
          <div class="card-body">
            <div class="form-group w-50">
              <div class="d-flex justify-content-between align-items-end mb-2">
                <label class="form-label mx-0" for="artistNotes">{{ 'viewArtist.artistNotes' | transloco }}</label>
                <p-button type="button" icon="pi pi-save" class="p-button-sm" [outlined]="true"
                  severity="secondary" (click)="saveConnectedArtistSettings()" [label]="'viewArtist.saveNotes' | transloco"
                  [disabled]="!settingData.ArtistNotes || settingData.ArtistNotes.trim().length === 0">
                </p-button>
              </div>
              <div class="position-relative">
                <textarea class="form-control" id="artistNotes" name="artistNotes"
                  [(ngModel)]="settingData.ArtistNotes" rows="3" [placeholder]="'viewArtist.enterArtistNotes' | transloco">
                </textarea>
                <div class="emoji-icon position-absolute cursor-pointer fs-5"
                  (click)="openEmojiDialog()"
                  style="top: 70%; right: 1rem; transform: translateY(-50%);">
                  😍
                </div>
              </div>
              <div class="small fst-italic text-muted mt-2"><i class="fa fa-info-circle me-1"></i> {{ 'viewArtist.fieldVisibleOnlyToYou' | transloco }}
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center mt-2 w-100">
      <div class="d-flex flex-column justify-content-start align-items-start">
        <div class="d-flex align-items-center fs-5 fw-semibold">
          {{ 'viewArtist.currentInventory' | transloco }}
          @if (availableArtworks > 0) {
            <span class="badge rounded-pill text-bg-secondary d-flex align-items-center ms-1"
            >{{availableArtworks}}</span>
          }
        </div>
        <div class="small text-muted">{{ 'viewArtist.searchHint' | transloco }}</div>
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center border-top mt-2 py-2">
      <div class="form-group me-2 w-100">
        <p-dropdown [options]="artistArtTypes" inputId="artistArtTypes" [filter]="true" [filterBy]="'label'"
          [optionLabel]="'label'" [optionValue]="'value'" name="artistArtTypes"
          [placeholder]="'viewArtist.filterByArtType' | transloco" [(ngModel)]="filters.ArtTypeId" [showClear]="true"
          (onChange)="onArtTypedChanged($event)">
        </p-dropdown>
      </div>
      <div class="form-group me-2 w-100">
        <p-dropdown [options]="productSeries" inputId="productSeries" name="productSeries"
          [placeholder]="'viewArtist.filterBySeries' | transloco" [disabled]="!filters.ArtTypeId" [filter]="true"
          [showClear]="true" [filterBy]="'label'" [optionLabel]="'label'" [optionValue]="'value'"
          [(ngModel)]="filters.ProductSeriesId" (onChange)="onProductSeriesChange($event)">
        </p-dropdown>
      </div>

      <div class="form-group me-2 w-100">
        <p-dropdown [options]="statusFilterOptions" [filter]="true" [showClear]="true" [filterBy]="'label'"
          [optionLabel]="'label'" [optionValue]="'value'" inputId="statusFilter" name="statusFilter"
          [placeholder]="'viewArtist.filterByStatus' | transloco" [(ngModel)]="filters.Status"
        (onChange)="onStatusFilterChange($event)"></p-dropdown>
      </div>
      <!-- Filter Input -->
      <div class="form-group me-2 w-100">
        <input type="search" class="form-control" id="globalFilter" [(ngModel)]="filters.Query"
          (input)="onGlobalFilterProduct()" [placeholder]="'viewArtist.filterItems' | transloco" />
        </div>

        <!-- Clear All Filters Button -->
        <div class="form-group me-2 w-100">
          <p-button type="button" icon="pi pi-times" iconPos="left" (click)="clearAllFilters($event)"
          [label]="'viewArtist.clearAll' | transloco" [outlined]="true" severity="secondary"> </p-button>
        </div>
      </div>
    </div>
    @if (artistProductsLoaded && artistProducts && artistProducts.length > 0) {
      <ds-artwork-grid context="gallery-artist-products" #pg class="mt-2 d-block">
        @for (product of artistProducts; track product) {
          <artist-product-tile [product]="product" [size]="pg.size"></artist-product-tile>
        }
      </ds-artwork-grid>
    } @else {
      @if (artistProductsLoaded && (!artistProducts || artistProducts.length === 0)) {
        <div
          class="alert alert-secondary py-2 text-center mt-3">
          {{ 'viewArtist.noRecordsFound' | transloco }}
        </div>
      }
    }
  </div>
</div>
@if (showArtistOverlayPanel) {
  <artist-overlay [visible]="showArtistOverlayPanel" [artistId]="artistId" (onClosed)="onArtistOverlayClosed($event)">
  </artist-overlay>
}


<!-- Emoji Picker Dialog -->
@if (displayEmojiDialog) {
  <app-emoji-list [showDialog]="displayEmojiDialog" (onClose)="closeEmojiDialog($event)"
    (emojiClick)="addEmoji($event)">
  </app-emoji-list>
}